"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
function JetBanner() {
    var _a;
    var page = (0, useTypedPage_1.default)();
    var body = react_1.default.createElement("p", null, (_a = page.props.jetstream.flash) === null || _a === void 0 ? void 0 : _a.banner) || "";
    var _b = (0, q_play_components_1.useModal)(), isShown = _b.isShown, toggle = _b.toggle;
    (0, react_1.useEffect)(function () {
        var _a;
        if ((_a = page.props.jetstream.flash) === null || _a === void 0 ? void 0 : _a.banner)
            toggle();
    }, []);
    return (react_1.default.createElement("div", null, body ? (react_1.default.createElement(q_play_components_1.Modal, { isShown: isShown, onClose: toggle, body: body, centered: true })) : null));
}
exports.default = JetBanner;
